module.exports = __webpack_public_path__ + "img/jyServiceItem2.15e6f55a.png";